import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';

import GenericButton from './GenericButton';
import GenericFileUpload from './GenericFileUpload';

export default class GenericSendToPopover extends Component {
  constructor(props) {
    super(props);
    this.state = { isVisible: false };
  }

  handleClick = () => this.setState({ isVisible: !this.state.isVisible });

  renderDropDown = () =>
    this.props.dropdownOptions.map(dropdownOption => {
      if (dropdownOption.type === 'fileUpload') {
        return (
          <GenericFileUpload
            key={uuid()}
            name={dropdownOption.name}
            btnStyle="button display-block button-100pt"
            btnDisabled={dropdownOption.disabled}
            handleUpload={dropdownOption.onUploadHandler}
          />
        );
      }

      return (
        <GenericButton
          key={uuid()}
          name={dropdownOption.name}
          btnStyle="button display-block button-100pt"
          btnDisabled={dropdownOption.disabled}
          onBtnClick={() => {
            dropdownOption.onClickHandler();
            this.handleClick();
          }}
        />
      );
    });

  render() {
    return (
      <div className="inline">
        <GenericButton
          name={this.props.btnName}
          btnStyle={this.props.btnStyle}
          btnDisabled={this.props.btnDisabled}
          onBtnClick={this.handleClick}
        />
        <div
          className={
            this.state.isVisible
              ? 'dropdown-pane-custom top'
              : 'dropdown-pane top showComponent'
          }
          data-dropdown
        >
          <div className="row expanded">
            <div className="large-12 columns">{this.renderDropDown()}</div>
          </div>
        </div>
      </div>
    );
  }
}

GenericSendToPopover.defaultProps = {
  btnStyle: 'button',
};

GenericSendToPopover.propTypes = {
  dropdownOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  btnDisabled: PropTypes.bool,
  btnName: PropTypes.string,
  btnStyle: PropTypes.string,
};
